/** ----------------------------------------
    Footer
 ---------------------------------------- */

/**
 * This class will handle the toggle of the
 * locations and related openings hours.
 */

export class Footer {

    /**
     * @init            calls the init method
     */

    constructor() {
        this.init();
    }

    /** ----------------------------------------
        Toggle Location
     ---------------------------------------- */

    toggleEvent() {
        let locations = document.querySelector('.footer__locations');
        if(!locations) return;

        let buildings = locations.querySelectorAll('.footer__location');

        buildings[0].classList.add('is-active');

        for (let i = 0; i < buildings.length; i++) {
            buildings[i].addEventListener('click', (e) => {
                this.setActive(e.target);
                this.selectTimes(parseInt(buildings[i].dataset.id));
            });
        }
    }

    setActive(element) {
        let name = '.' + element.classList[0];
        let parent = element.parentNode;
        let elements = parent.querySelectorAll(name);

        [...elements].map(item => item.classList.remove('is-active'));

        element.classList.toggle('is-active');
    }

    /** ----------------------------------------
        Set Location
     ---------------------------------------- */

    selectTimes(id) {
        let opened = document.querySelector('.footer__opened');
        if(!opened) return;

        let times = opened.querySelectorAll('.footer__open');

        for (let i = 0; i < times.length; i++) {
            times[i].style.display = 'none';

            if(parseInt(times[i].dataset.id) === id)
                times[i].style.display = 'block';
        }
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    /**
     * This function is called within the
     * constructor and will initiate once the
     * class is loaded.
     */

    init() {
        let theme = document.body.dataset.theme;

        if(theme !== 'wca') {
            this.selectTimes(1);
            this.toggleEvent();
        }
    }

}